var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-chart"},[(_vm.waiting)?_c('v-skeleton-loader',{staticStyle:{"padding":"20px 0","margin-bottom":"24px"},attrs:{"height":200,"type":"image"}}):_c('apexcharts',{ref:"bars",attrs:{"width":"300","type":"bar","height":180,"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }